export function NotAuthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md text-center space-y-3">
        <h1 className="text-2xl font-semibold">Not authenticated</h1>
        <p className="text-muted-foreground">
          Open the dashboard from your invite link (it includes the access token in the URL).
        </p>
      </div>
    </div>
  );
}
